import { AI_STORAGE_KEYS } from '../constants/index.ts';

/**
 * Tạo khóa localStorage phân vùng theo người dùng để lưu ID cuộc trò chuyện.
 * Đảm bảo các tài khoản khác nhau trên cùng thiết bị không bị lẫn lộn lịch sử chat.
 *
 * @param userId - ID người dùng đã xác thực (từ authUser.id)
 * @returns Khóa lưu trữ cục bộ tương ứng
 */
export function getChatIdStorageKey(userId: string | undefined): string {
  return userId ? `${AI_STORAGE_KEYS.CHAT_ID_PREFIX}-${userId}` : AI_STORAGE_KEYS.CHAT_ID_GUEST;
}
